/* eslint-disable no-empty */
/* eslint-disable prefer-const */
/* eslint-disable padded-blocks */
/* eslint-disable arrow-body-style */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable arrow-parens */
/* eslint-disable object-property-newline */
/* eslint-disable semi */
/* eslint-disable indent */
/* eslint-disable padding-line-between-statements */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useRef, useState } from 'react';
import './tabela-cadastro-edicao-precos.css';
import { MultiSelect } from 'primereact/multiselect';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { VscSave } from 'react-icons/vsc';
import { BiCalendarPlus } from 'react-icons/bi';
import { MdDeleteForever } from 'react-icons/md';
import { AiOutlineCheck } from 'react-icons/ai';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import cidadesEstadosService from '../../services/cidades-estados/cidades-estados-service';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import ReactInputMask from 'react-input-mask';
import CurrencyInput from './currency-input';
import { ProgressSpinner } from 'primereact/progressspinner';
import DialogSuccessNoReload from '../dialogs/dialog-sucesso-sem-reload';
import DialogErrorNoReload from '../dialogs/dialog-error-sem-reload';
import { removerSpecials } from './removerCaracteresEspeciais';
import { Growl } from 'primereact/growl';
import { Calendar } from 'primereact/calendar';
import { ptBR } from './calendarLocation';
import { Checkbox } from '@material-ui/core';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { BuscarProduto } from '../../services/produtos';
import { adesaoSchema } from '../tabela-cadastro-edicao-precos-mensalidades/validation/yupAdesaoSchema';
import moment from 'moment';
export default function TabelaCadastroEdicaoPrecos() {
    let dt = useRef(null);
    let messages = useRef(null);

    const [planos, setPlanos] = useState();
    const [planoSelecionado, setPlanoSelecionado] = useState();
    const [cidades, setCidades] = useState();
    const [cidadeSelecionada, setCidadeSelecionada] = useState();
    const [estados, setEstados] = useState();
    const [estadoSelecionado, setEstadoSelecionado] = useState();
    const [planosSelecionados, setPlanosSelecionados] = useState([]);
    const [globalFilter, setGlobalFilter] = useState();
    const [loadEnvioPlanos, setLoadEnvioPlanos] = useState(false);
    const [openDialogSuccess, setOpenDialogSuccess] = useState(false);
    const [openDialogError, setOpenDialogError] = useState(false);
    const [dialogMessageErr, setDialogMessageErr] = useState('');
    const [loading, setLoading] = useState(false);

    const loadPlanos = async () => {
        let planos = (await BuscarProduto())?.map((item) => item.SubGrupo.trim());
        planos = [...new Set(planos)].map((item) => {
            return { label: item.toUpperCase(), value: item };
        });
        setPlanos(planos);
    };
    const loadEstados = async () => {
        const estados = (await cidadesEstadosService.getEstadosBrasil()).map((item) => {
            return { label: item.nome, value: item.sigla };
        });
        setEstados(estados);
    };

    const loadInicial = async () => {
        try {
            setLoading(true);
            await loadEstados();
            await loadPlanos();
            showSuccessMessage('Planos e Estados carregados com sucesso!');
            setLoading(false);
        } catch (error) {
            showErrorMessage(
                error.message ?
                    error.message :
                    'Algo deu errado, tente novamente mais tarde!'
            );
            return Error(error.message);
        }
    };

    useEffect(() => {
        loadInicial();
    }, []);

    useEffect(() => {
        const loadCidades = async () => {
            try {
                setLoading(true);

                const cidades = (
                    await cidadesEstadosService.getCidadesEstado(estadoSelecionado[0])
                ).map((item) => {
                    return {
                        label: item.nome,
                        value: { id: item.id, label: item.nome }
                    };
                });
                setCidades(cidades);
                showSuccessMessage('Cidades carregadas com sucesso!');
                setLoading(false);
            } catch (error) {
                showErrorMessage(
                    error.message ?
                        error.message :
                        'Algo deu errado, tente novamente mais tarde!'
                );
                setLoading(false);
            }
        };

        if (estadoSelecionado) {
            loadCidades();
        }
    }, [estadoSelecionado]);

    useEffect(() => {
        const clearCidades = async () => {
            setCidadeSelecionada([]);
        };

        clearCidades();
    }, [cidades]);

    const onAgendamento = async (values, resetForm, setErrors) => {
        try {
            setLoadEnvioPlanos(true);

            const percentualDesconto = formatPercentage(values.descontoPercentual);

            if (percentualDesconto !== 0 && !percentualDesconto) {
                throw new Error('Percentual de desconto inválido!');
            }

            if (percentualDesconto > 99.99) {
                throw new Error('Percentual de desconto deve ser menor que 100%!');
            }

            if (percentualDesconto < 0) {
                throw new Error('Percentual de desconto deve ser positivo');
            }

            let tipoDesconto = 'm';
            if (values.descontoPercentual) {
                tipoDesconto = 'p';
            }

            const { pagamentoBoleto, pagamentoCartao, pagamentoEscelsa } = values;

            const formaPagamento = [];

            if (pagamentoBoleto) {
                formaPagamento.push(1);
            }

            if (pagamentoCartao) {
                formaPagamento.push(7);
            }

            if (pagamentoEscelsa) {
                formaPagamento.push(8);
            }

            const edicaoPlanos = {
                planosCidadesAlteradas: planosSelecionados.map((plano) => {
                    return { ...plano, cidade: plano.cidade.id };
                }),
                detalhesPlano: {
                    carenciaPromocional:
                        values.carenciaPromocional === undefined ?
                            null :
                            formatNumberDias(values.carenciaPromocional),
                    carenciaSemPromocao:
                        values.carenciaSemPromocao === undefined ?
                            null :
                            formatNumberDias(values.carenciaSemPromocao),
                    cremacao:
                        values.cremacao === undefined ?
                            null :
                            formatValor(values.cremacao),
                    novo: values.novo === undefined ? null : formatValor(values.novo),
                    reabilitacao:
                        values.reabilitacao === undefined ?
                            null :
                            formatValor(values.reabilitacao),
                    troca:
                        values.troca === undefined ? null : formatValor(values.troca),
                    dataInicioDesconto:
                        values.dataInicioDesconto === '' ?
                            null :
                            moment(values.dataInicioDesconto)
                                .utc(true)
                                .add(3, 'hours'),
                    dataFinalDesconto:
                        values.dataFinalDesconto === '' ?
                            null :
                            moment(values.dataFinalDesconto)
                                .utc(true)
                                .add(3, 'hours'),
                    valorDesconto: percentualDesconto ?
                        percentualDesconto :
                        Number(values.descontoValor),
                    atualizarSomenteValorDesconto: values.atualizarSomenteValorDesconto,
                    tipoDesconto,
                    formaPagamento
                },
                usuario: decriptObjectOnLocalStorage('IDuser'),
                tipo: 'adesao',
                dataAgendamento: values.dataAgendamento
            };
            if (edicaoPlanos.detalhesPlano.valorDesconto === 0 && !edicaoPlanos.detalhesPlano.atualizarSomenteValorDesconto) {
                delete edicaoPlanos.detalhesPlano.valorDesconto;
                delete edicaoPlanos.detalhesPlano.dataInicioDesconto;
                delete edicaoPlanos.detalhesPlano.dataFinalDesconto;
                delete edicaoPlanos.detalhesPlano.tipoDesconto;
            }
            await cidadesEstadosService.postAgendamento(edicaoPlanos);
            setOpenDialogSuccess(true);
            setCidadeSelecionada(null);
            setEstadoSelecionado(null);
            setPlanoSelecionado(null);
            setPlanosSelecionados([]);
            setGlobalFilter(null);
            setLoadEnvioPlanos(false);
            resetForm();
        } catch (err) {
            console.log(err);
            showErrorMessage(err.message);
            setLoadEnvioPlanos(false);
            setDialogMessageErr(err.message);
            setOpenDialogError(true);
        }
    };

    const onSubmit = async (values, resetForm) => {
        try {
            setLoadEnvioPlanos(true);

            const percentualDesconto = formatPercentage(values.descontoPercentual);

            if (percentualDesconto !== 0 && !percentualDesconto) {
                throw new Error('Percentual de desconto inválido!');
            }

            if (percentualDesconto > 99.99) {
                throw new Error('Percentual de desconto deve ser menor que 100%!');
            }

            if (percentualDesconto < 0) {
                throw new Error('Percentual de desconto deve ser positivo');
            }
            let tipoDesconto = 'm';
            if (values.descontoPercentual) {
                tipoDesconto = 'p';
            }

            const { pagamentoBoleto, pagamentoCartao, pagamentoEscelsa } = values;

            const formaPagamento = [];

            if (pagamentoBoleto) {
                formaPagamento.push(1);
            }

            if (pagamentoCartao) {
                formaPagamento.push(7);
            }

            if (pagamentoEscelsa) {
                formaPagamento.push(8);
            }

            const edicaoPlanos = {
                planosCidadesAlteradas: planosSelecionados.map((plano) => {
                    return { ...plano, cidade: plano.cidade.id };
                }),
                detalhesPlano: {
                    carenciaPromocional:
                        values.carenciaPromocional === undefined ?
                            null :
                            formatNumberDias(values.carenciaPromocional),
                    carenciaSemPromocao:
                        values.carenciaSemPromocao === undefined ?
                            null :
                            formatNumberDias(values.carenciaSemPromocao),
                    cremacao:
                        values.cremacao === undefined ?
                            null :
                            formatValor(values.cremacao),
                    novo: values.novo === undefined ? null : formatValor(values.novo),
                    reabilitacao:
                        values.reabilitacao === undefined ?
                            null :
                            formatValor(values.reabilitacao),
                    troca:
                        values.troca === undefined ? null : formatValor(values.troca),
                    dataInicioDesconto:
                        values.dataInicioDesconto === '' ?
                            null :
                            moment(values.dataInicioDesconto)
                                .utc(true)
                                .add(3, 'hours'),
                    dataFinalDesconto:
                        values.dataFinalDesconto === '' ?
                            null :
                            moment(values.dataFinalDesconto)
                                .utc(true)
                                .add(3, 'hours'),
                    valorDesconto: percentualDesconto ?
                        percentualDesconto :
                        Number(values.descontoValor),
                    atualizarSomenteValorDesconto: values.atualizarSomenteValorDesconto,
                    tipoDesconto,
                    formaPagamento
                },
                usuario: decriptObjectOnLocalStorage('IDuser'),
                tipo: 'adesao'
            };
            if (edicaoPlanos.detalhesPlano.valorDesconto === 0 && !edicaoPlanos.detalhesPlano.atualizarSomenteValorDesconto) {
                delete edicaoPlanos.detalhesPlano.valorDesconto;
                delete edicaoPlanos.detalhesPlano.dataInicioDesconto;
                delete edicaoPlanos.detalhesPlano.dataFinalDesconto;
                delete edicaoPlanos.detalhesPlano.tipoDesconto;
            }

            const response = await cidadesEstadosService.postPlanos(edicaoPlanos);

            if (response.planosAtualizados === 0 && response.planosCriados === 0) {
                throw new Error('Plano não cadastrado!');
            }
            setOpenDialogSuccess(true);
            setCidadeSelecionada(null);
            setEstadoSelecionado(null);
            setPlanoSelecionado(null);
            setPlanosSelecionados([]);
            setGlobalFilter(null);
            resetForm();
            setLoadEnvioPlanos(false);
        } catch (err) {
            console.log(err);
            showErrorMessage(err.message);
            setLoadEnvioPlanos(false);
            setDialogMessageErr(err.message);
            setOpenDialogError(true);
        }
    };

    const formatNumberDias = (dias) => {
        const regExDias = /\D/g;
        return Number(dias.replace(regExDias, ''));
    };

    const formatValor = (dias) => {
        const regexMoedaEspacos = /R\$/g;
        return Number(dias.replace(regexMoedaEspacos, '').replace(',', '.'));
    };
    const formatPercentage = (valor) => {
        const numeroFormatado = Number(
            `${valor}`.replace('%', '').replace(',', '.').replace(' ', '')
        );
        return numeroFormatado;
    };

    const adicionarPlano = () => {
        const adicionarPlanos = [];
        const planosJaExistentes = [];

        try {
            if (!cidadeSelecionada.length) {
                throw new Error('Selecione uma cidade');
            }

            if (cidadeSelecionada.length === 1) {
                const plano = {
                    plano: planoSelecionado[0],
                    estado: estadoSelecionado[0],
                    cidade: cidadeSelecionada[0]
                };
                if (!checarSeExiste(plano)) {
                    setPlanosSelecionados([...planosSelecionados, plano]);
                    showSuccessMessage(
                        'Plano adicionado adicionado na lista para alterações'
                    );
                    return;
                } else {
                    throw new Error('Plano já adicionado na lista para alterações');
                }
            }
            for (const cidadePlano of cidadeSelecionada) {
                const plano = {
                    plano: planoSelecionado[0],
                    estado: estadoSelecionado[0],
                    cidade: cidadePlano
                };

                if (!checarSeExiste(plano)) {
                    adicionarPlanos.push(plano);
                } else {
                    planosJaExistentes.push(plano);
                }
            }
            if (planosJaExistentes.length === cidadeSelecionada.length) {
                throw new Error('Planos já adicionados na lista para alterações');
            }
            setPlanosSelecionados([...planosSelecionados, ...adicionarPlanos]);
            showSuccessMessage('Planos adicionados na lista para alterações');

            return;
        } catch (error) {
            showWarnMessage(error.message);
            return error;
        }
    };

    const deletarPlano = (plano) => {
        const indexPlano = planosSelecionados.indexOf(plano);
        setPlanosSelecionados(
            planosSelecionados.filter((element, index) => index !== indexPlano)
        );
        showSuccessMessage('Plano deletado da lista para alterações');
    };

    const limparTodosPlanos = () => {
        setPlanosSelecionados([]);
        showSuccessMessage('Planos deletados da lista para alterações');
    };

    const changeMultiSelectPlano = (e) => {
        if (e.value.length > 0) {
            setPlanoSelecionado([e.value[e.value.length - 1]]);
        }
    };
    const changeMultiSelectEstado = (e) => {
        if (e.value.length > 0) {
            setEstadoSelecionado([e.value[e.value.length - 1]]);
        }
    };
    const changeMultiSelectCidade = (e) => {
        setCidadeSelecionada(e.value);
    };

    const checarSeExiste = (plano) => {
        if (planosSelecionados.length === 0) {
            return false;
        }
        for (const item of planosSelecionados) {
            if (
                item.plano === plano.plano &&
                item.estado === plano.estado &&
                item.cidade === plano.cidade
            ) {
                return true;
            }
        }

        return false;
    };

    const filterCidades = (value, filter) => {
        return removerSpecials(value.label.toLowerCase()).includes(
            removerSpecials(filter.toLowerCase())
        );
    };

    const showWarnMessage = (detail) => {
        messages.current.show({ severity: 'warn', detail, closable: true, life: 3000 });
    };

    const showErrorMessage = (detail) => {
        messages.current.show({
            severity: 'error',
            detail,
            closable: true,
            life: 3000
        });
    };

    const showSuccessMessage = (detail) => {
        messages.current.show({
            severity: 'success',
            detail,
            closable: true,
            life: 3000
        });
    };

    const handleChangeDescontoPercentual = (e, values, setFieldValue) => {
        setFieldValue('descontoValor', '');
        const desconto = e.target.value;
        setFieldValue('descontoPercentual', desconto);

        const newValues = { desconto, novo: values.novo };

        calculaValorComDesconto(newValues, setFieldValue, 'percentual');
    };

    const handleChangeDescontoValor = (e, values, setFieldValue) => {
        setFieldValue('descontoPercentual', '');
        const desconto = e.target.value;
        setFieldValue('descontoValor', desconto);

        const newValues = { desconto, novo: values.novo };

        calculaValorComDesconto(newValues, setFieldValue);
    };

    const handleChangeNovo = (e, values, setFieldValue) => {
        const novo = e.target.value;
        setFieldValue('novo', novo);
        let auxValorDesconto = '';
        let auxTipoDesconto = '';
        auxValorDesconto = values.descontoValor;
        if (values.descontoPercentual) {
            auxValorDesconto = values.descontoPercentual;
            auxTipoDesconto = 'percentual';
        }
        const newValues = { desconto: auxValorDesconto, novo };

        calculaValorComDesconto(newValues, setFieldValue, auxTipoDesconto);
    };

    const calculaValorComDesconto = (values, setFieldValue, tipo) => {
        const { desconto, novo } = values || {};
        const valorAdesaoNovo =
            novo && Number(novo.replace('R', '').replace('$', '').replace(',', '.'));
        if (tipo === 'percentual') {
            const percentualDesconto = (desconto ? desconto : 0) / 100;

            const total =
                valorAdesaoNovo &&
                valorAdesaoNovo - valorAdesaoNovo * percentualDesconto;

            const totalAux = total && `${total}`.replace('.', ',');

            if (totalAux && totalAux !== values.valorComDesconto) {
                setFieldValue('valorComDesconto', totalAux);
            }
            return;
        }
        const totalComDescontoValor = valorAdesaoNovo - Number(desconto ?? 0);

        setFieldValue(
            'valorComDesconto',
            String(totalComDescontoValor).replace('.', ',')
        );
        return;
    };

    const handleChangeSomentePercentual = (e, setFieldValue, handleChange) => {
        handleChange(e);
        setFieldValue('somenteStatus', false);
        setFieldValue('carenciaPromocional', '');
        setFieldValue('novo', '');
        setFieldValue('troca', '');
        setFieldValue('reabilitacao', '');
        setFieldValue('cremacao', '');
        setFieldValue('carenciaSemPromocao', '');
        setFieldValue('dataInicioDesconto', '');
        setFieldValue('dataFinalDesconto', '');
    };

    const renderHeader = () => {
        return (
            <div className="header-table-cadastro-edicao-precos">
                <div className="title-header-table-cadastro">
                    <h2>Planos Selecionados</h2>
                    <p>Todos planos selecionados receberão as configurações</p>
                </div>
                <div className="menu-header-table-cadastro">
                    <input
                        placeholder="Faça uma busca global"
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        className="input-empty"
                    />
                    <button
                        disabled={planosSelecionados.length === 0 || loadEnvioPlanos}
                        onClick={limparTodosPlanos}
                    >
                        <MdDeleteForever size={20} color="white" />
                        <span>Deletar tudo</span>
                    </button>
                </div>
            </div>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions-table-cadastro-edicao-precos">
                <button
                    onClick={() => deletarPlano(rowData)}
                    disabled={loadEnvioPlanos}
                >
                    <MdDeleteForever size={18} />
                    <span>Deletar</span>
                </button>
            </div>
        );
    };

    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);

    return (
        <div className="page-cadastro-edicao-precos-lote">
            <Growl ref={messages} />
            <div className="div-title-cadastro-edicao-precos">
                <div className="traco-vertical"></div>
                <div className="title-cadastro-edicao-precos">
                    <h1>Cadastro e Edição de planos</h1>
                    <p>
                        Selecione todos os planos que deseja incluir ou alterar de uma
                        vez só
                    </p>
                </div>
            </div>

            <div className="form-cadastro-edicao-precos">
                <MultiSelect
                    value={planoSelecionado}
                    options={planos}
                    onChange={changeMultiSelectPlano}
                    filter={true}
                    filterPlaceholder="Procurar"
                    placeholder="Escolha um plano"
                    className="select-cadastro-edicao-precos"
                    disabled={loadEnvioPlanos}
                />
                <MultiSelect
                    value={estadoSelecionado}
                    options={estados}
                    onChange={changeMultiSelectEstado}
                    filter={true}
                    filterPlaceholder="Procurar"
                    placeholder="Escolha um estado"
                    className="select-cadastro-edicao-precos"
                    disabled={loadEnvioPlanos}
                />
                <MultiSelect
                    value={cidadeSelecionada}
                    options={cidades}
                    onChange={changeMultiSelectCidade}
                    maxSelectedLabels={3}
                    selectedItemsLabel={'{0} itens selecionados'}
                    filter={true}
                    filterPlaceholder="Procurar"
                    placeholder="Escolha uma cidade"
                    className="select-cadastro-edicao-precos-cidades"
                    disabled={!estadoSelecionado || loadEnvioPlanos}
                />
                <button
                    onClick={adicionarPlano}
                    disabled={
                        !planoSelecionado ||
                        !estadoSelecionado ||
                        !cidadeSelecionada ||
                        loadEnvioPlanos
                    }
                    className="form-cadastro-edicao-precos-button"
                >
                    <IoMdAddCircleOutline size={25} color="white" />
                    <span>Adicionar</span>
                </button>
            </div>

            <div className="table-cadastro-edicao-precos">
                <DataTable
                    ref={dt}
                    value={planosSelecionados}
                    responsive
                    dataKey="Referencia"
                    rowHover
                    globalFilter={globalFilter}
                    header={renderHeader()}
                    paginator
                    rows={5}
                    emptyMessage="Ainda não há planos selecionados"
                    currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} resultados encontrados"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10]}
                >
                    <Column
                        field="plano"
                        header="Plano"
                        filter
                        filterPlaceholder="Buscar plano dentre os selecionados"
                    />
                    <Column
                        field="estado"
                        header="Estado"
                        filter
                        filterPlaceholder="Buscar estado dentre os selecionados"
                    />
                    <Column
                        field="cidade.label"
                        header="Cidade"
                        filter
                        filterPlaceholder="Buscar cidade dentre as selecionados"
                    />
                    <Column
                        body={actionBodyTemplate}
                        headerStyle={{ width: '8em', textAlign: 'center' }}
                        bodyStyle={{ textAlign: 'center', overflow: 'visible' }}
                    />
                </DataTable>
            </div>
            {planosSelecionados.length > 0 && (
                <Formik
                    initialValues={{
                        valorComDesconto: '0',
                        dataAgendamento: amanha,
                        descontoPercentual: null,
                        descontoValor: null,
                        clearDescontoValor: true,
                        clearDescontoPercentual: true,
                        troca: '',
                        novo: '',
                        carenciaPromocional: '',
                        carenciaSemPromocao: '',
                        reabilitacao: '',
                        cremacao: '',
                        atualizarSomenteValorDesconto: false,
                        dataInicioDesconto: '',
                        dataFinalDesconto: '',
                        pagamentoCartao: false,
                        pagamentoBoleto: false,
                        pagamentoEscelsa: false,
                        formasPagamento: ''
                    }}
                    validateOnBlur
                    validationSchema={adesaoSchema}
                    onSubmit={(values, { resetForm }) => onSubmit(values, resetForm)}
                >
                    {({ handleChange, resetForm, values, setFieldValue, isValid, validateForm, setErrors }) => (
                        <Form
                            className="form-cadastro-edicao-planos"
                            style={loadEnvioPlanos ? { display: 'none' } : {}}
                        >
                            <div className="header-form-dados">
                                <div className="header-form-dados-title">
                                    <h2>Dados do plano</h2>
                                    <p>
                                        Defina as caracteristicas que os planos irão
                                        receber
                                    </p>
                                </div>

                                <div className="checkboxDiv">
                                    <Field
                                        name="atualizarSomenteValorDesconto"
                                        render={() => (
                                            <>
                                                <div
                                                    className="checkbox"
                                                    style={{
                                                        display: 'flex',
                                                        width: '20%'
                                                    }}
                                                >
                                                    <Checkbox
                                                        name="atualizarSomenteValorDesconto"
                                                        id="atualizarSomenteValorDesconto"
                                                        checked={
                                                            values.atualizarSomenteValorDesconto
                                                        }
                                                        onChange={(e) =>
                                                            handleChangeSomentePercentual(
                                                                e,
                                                                setFieldValue,
                                                                handleChange
                                                            )
                                                        }
                                                        color="primary"
                                                    />
                                                    <label
                                                        htmlFor="atualizarSomenteValorDesconto"
                                                        className="p-checkbox-label"
                                                    >
                                                        Atualizar somente o desconto
                                                    </label>
                                                </div>
                                            </>
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="div-input">
                                <Field
                                    name="carenciaPromocional"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                touched[field.name] &&
                                                values.carenciaPromocional.length !==
                                                0 && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        Carência Promocional{' '}
                                                        <AiOutlineCheck
                                                            size={15}
                                                            color="green"
                                                            style={{
                                                                margin: '0 0 0 5px'
                                                            }}
                                                        />
                                                    </p>
                                                )}

                                            <div className="div-posicionamento-erro-validacao">
                                                <ReactInputMask
                                                    mask="999 di\as"
                                                    maskChar={' '}
                                                    disabled={
                                                        values.atualizarSomenteValorDesconto
                                                    }
                                                    placeholder="Carência Promocional"
                                                    onChange={handleChange}
                                                    className={
                                                        !touched[field.name] ||
                                                            !values.carenciaPromocional
                                                                .length ?
                                                            'input-empty' :
                                                            errors[field.name] ?
                                                                'input-wrong' :
                                                                'input-ok'
                                                    }
                                                    {...field}
                                                />
                                                {errors[field.name] &&
                                                    touched[field.name] && (
                                                        <p>{errors[field.name]}</p>
                                                    )}
                                            </div>
                                        </>
                                    )}
                                />
                            </div>

                            <div className="div-input">
                                <Field
                                    name="carenciaSemPromocao"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                touched[field.name] &&
                                                values.carenciaSemPromocao.length !==
                                                0 && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        Carência s/ Promoção{' '}
                                                        <AiOutlineCheck
                                                            size={15}
                                                            color="green"
                                                            style={{
                                                                margin: '0 0 0 5px'
                                                            }}
                                                        />
                                                    </p>
                                                )}
                                            <div className="div-posicionamento-erro-validacao">
                                                <ReactInputMask
                                                    mask="999 di\as"
                                                    maskChar={' '}
                                                    disabled={
                                                        values.atualizarSomenteValorDesconto
                                                    }
                                                    placeholder="Carência s/ Promoção"
                                                    onChange={handleChange}
                                                    className={
                                                        !touched[field.name] ||
                                                            !values.carenciaSemPromocao
                                                                .length ?
                                                            'input-empty' :
                                                            errors[field.name] ?
                                                                'input-wrong' :
                                                                'input-ok'
                                                    }
                                                    {...field}
                                                />
                                                {errors[field.name] &&
                                                    touched[field.name] && (
                                                        <p>{errors[field.name]}</p>
                                                    )}
                                            </div>
                                        </>
                                    )}
                                />
                            </div>

                            <div className="div-input">
                                <Field
                                    name="novo"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                touched[field.name] &&
                                                values.novo.lenght !== 0 && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        Novo{' '}
                                                        <AiOutlineCheck
                                                            size={15}
                                                            color="green"
                                                            style={{
                                                                margin: '0 0 0 5px'
                                                            }}
                                                        />
                                                    </p>
                                                )}
                                            <div className="div-posicionamento-erro-validacao">
                                                <CurrencyInput
                                                    name="novo"
                                                    onChange={(e) => {
                                                        handleChangeNovo(
                                                            e,
                                                            values,
                                                            setFieldValue
                                                        );
                                                    }}
                                                    value={values.novo}
                                                    disabled={
                                                        values.atualizarSomenteValorDesconto
                                                    }
                                                    placeholder="Novo"
                                                    className={
                                                        !touched[field.name] ||
                                                            !values.novo.length ?
                                                            'input-empty' :
                                                            errors[field.name] ?
                                                                'input-wrong' :
                                                                'input-ok'
                                                    }
                                                />
                                                {errors[field.name] &&
                                                    touched[field.name] && (
                                                        <p>{errors[field.name]}</p>
                                                    )}
                                            </div>
                                        </>
                                    )}
                                />
                            </div>

                            <div className="div-input div-input-desconto">
                                <Field
                                    name="descontoPercentual"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                touched[field.name] &&
                                                values.descontoPercentual !== '' && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        Desconto em %{' '}
                                                        <AiOutlineCheck
                                                            size={15}
                                                            color="green"
                                                            style={{
                                                                margin: '0 0 0 5px'
                                                            }}
                                                        />
                                                    </p>
                                                )}
                                            <div className="div-posicionamento-erro-validacao">
                                                <div className='div-input-alinhamento-mascara-descontos'>
                                                    <input
                                                        value={values.descontoPercentual}
                                                        name="descontoPercentual"
                                                        disabled={values.somenteStatus}
                                                        onChange={(e) => {
                                                            handleChangeDescontoPercentual(
                                                                e,
                                                                values,
                                                                setFieldValue
                                                            );
                                                        }}
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="Desconto em %"
                                                        className={
                                                            !touched[field.name] ||
                                                                values.descontoPercentual === '' ?
                                                                'input-empty' :
                                                                errors[field.name] ?
                                                                    'input-wrong' :
                                                                    'input-ok'
                                                        }
                                                    />
                                                    <span className="div-input-desconto-simbolo">
                                                        %
                                                    </span>
                                                </div>
                                                {errors[field.name] &&
                                                    touched[field.name] && (
                                                        <p>{errors[field.name]}</p>
                                                    )}
                                            </div>
                                        </>
                                    )}
                                />
                            </div>
                            <div className="div-input div-input-desconto">
                                <Field
                                    name="descontoValor"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                touched[field.name] &&
                                                values.descontoValor !== '' && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        Desconto em R${' '}
                                                        <AiOutlineCheck
                                                            size={15}
                                                            color="green"
                                                            style={{
                                                                margin: '0 0 0 5px'
                                                            }}
                                                        />
                                                    </p>
                                                )}
                                            <div className="div-posicionamento-erro-validacao">
                                                <div className='div-input-alinhamento-mascara-descontos'>
                                                    <input
                                                        value={values.descontoValor}
                                                        name="descontoValor"
                                                        onChange={(e) => {
                                                            handleChangeDescontoValor(
                                                                e,
                                                                values,
                                                                setFieldValue
                                                            );
                                                        }}
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="Desconto em R$"
                                                        className={
                                                            !touched[field.name] ||
                                                                values.descontoValor === '' ?
                                                                'input-empty' :
                                                                errors[field.name] ?
                                                                    'input-wrong' :
                                                                    'input-ok'
                                                        }
                                                    />
                                                    <span className="div-input-desconto-simbolo">
                                                        R$
                                                    </span>
                                                </div>
                                                {errors[field.name] &&
                                                    touched[field.name] && (
                                                        <p>{errors[field.name]}</p>
                                                    )}
                                            </div>
                                        </>
                                    )}
                                />
                            </div>
                            <div className="div-input">
                                <Field
                                    name="valorComDesconto"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                values.valorComDesconto && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        valor com desconto{' '}
                                                    </p>
                                                )}
                                            <CurrencyInput
                                                {...field}
                                                disabled
                                                placeholder="valor com desconto"
                                                className={'input-empty'}
                                            />
                                            {errors[field.name] &&
                                                touched[field.name] && (
                                                    <p>{errors[field.name]}</p>
                                                )}
                                        </>
                                    )}
                                />
                            </div>

                            <div className="div-input">
                                <Field
                                    name="troca"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                touched[field.name] &&
                                                values.troca.length !== 0 && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        Troca{' '}
                                                        <AiOutlineCheck
                                                            size={15}
                                                            color="green"
                                                            style={{
                                                                margin: '0 0 0 5px'
                                                            }}
                                                        />
                                                    </p>
                                                )}
                                            <CurrencyInput
                                                disabled={
                                                    values.atualizarSomenteValorDesconto
                                                }
                                                placeholder="Troca"
                                                className={
                                                    !touched[field.name] ||
                                                        !values.troca.length ?
                                                        'input-empty' :
                                                        errors[field.name] ?
                                                            'input-wrong' :
                                                            'input-ok'
                                                }
                                                {...field}
                                            />
                                            {errors[field.name] &&
                                                touched[field.name] && (
                                                    <p>{errors[field.name]}</p>
                                                )}
                                        </>
                                    )}
                                />
                            </div>

                            <div className="div-input">
                                <Field
                                    name="reabilitacao"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                touched[field.name] &&
                                                values.reabilitacao.length !== 0 && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        Reabilitação{' '}
                                                        <AiOutlineCheck
                                                            size={15}
                                                            color="green"
                                                            style={{
                                                                margin: '0 0 0 5px'
                                                            }}
                                                        />
                                                    </p>
                                                )}
                                            <CurrencyInput
                                                disabled={
                                                    values.atualizarSomenteValorDesconto
                                                }
                                                placeholder="Reabilitação"
                                                className={
                                                    !touched[field.name] ||
                                                        !values.reabilitacao.length ?
                                                        'input-empty' :
                                                        errors[field.name] ?
                                                            'input-wrong' :
                                                            'input-ok'
                                                }
                                                {...field}
                                            />
                                            {errors[field.name] &&
                                                touched[field.name] && (
                                                    <p>{errors[field.name]}</p>
                                                )}
                                        </>
                                    )}
                                />
                            </div>

                            <div className="div-input">
                                <Field
                                    name="cremacao"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            {!errors[field.name] &&
                                                touched[field.name] &&
                                                values.cremacao.length !== 0 && (
                                                    <p className="label-ok">
                                                        {' '}
                                                        Cremação{' '}
                                                        <AiOutlineCheck
                                                            size={15}
                                                            color="green"
                                                            style={{
                                                                margin: '0 0 0 5px'
                                                            }}
                                                        />
                                                    </p>
                                                )}
                                            <CurrencyInput
                                                disabled={
                                                    values.atualizarSomenteValorDesconto
                                                }
                                                placeholder="Cremação"
                                                className={
                                                    !touched[field.name] ||
                                                        !values.cremacao.length ?
                                                        'input-empty' :
                                                        errors[field.name] ?
                                                            'input-wrong' :
                                                            'input-ok'
                                                }
                                                {...field}
                                            />
                                            {errors[field.name] &&
                                                touched[field.name] && (
                                                    <p>{errors[field.name]}</p>
                                                )}
                                        </>
                                    )}
                                />
                            </div>
                            <div className="div-input">
                                <div className="div-posicionamento-erro-validacao">
                                    <Field
                                        as={Calendar}
                                        name="dataInicioDesconto"
                                        id="dataInicioDesconto"
                                        locale={ptBR}
                                        placeholder="Data inicio desconto"
                                        minDate={amanha}
                                        style={{ width: '100%' }}
                                        dateFormat="dd/mm/yy"

                                    />
                                    <ErrorMessage
                                        component="span"
                                        name="dataInicioDesconto"
                                        style={{ color: 'red', fontSize: 12 }}
                                    />
                                </div>
                            </div>
                            <div className="div-input">
                                <div className="div-posicionamento-erro-validacao">
                                    <Field
                                        as={Calendar}
                                        name="dataFinalDesconto"
                                        id="dataFinalDesconto"
                                        locale={ptBR}
                                        placeholder="Data final desconto"
                                        minDate={amanha}
                                        style={{ width: '100%' }}
                                        dateFormat="dd/mm/yy"

                                    />
                                    <ErrorMessage
                                        component="span"
                                        name="dataFinalDesconto"
                                        style={{ color: 'red', fontSize: 12 }}
                                    />
                                </div>
                            </div>

                            <div className="div-input">
                                <div className="div-posicionamento-erro-validacao">
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div className="checkboxDivFormasPagamento">
                                            <Field
                                                as={Checkbox}
                                                name="pagamentoCartao"
                                                id="pagamentoCartao"
                                                color="primary"

                                            />
                                            <label className="p-checkbox-label">
                                                Cartão
                                            </label>
                                        </div>
                                        <div className="checkboxDivFormasPagamento">
                                            <Field
                                                as={Checkbox}
                                                name="pagamentoBoleto"
                                                id="pagamentoBoleto"
                                                color="primary"

                                            />
                                            <label className="p-checkbox-label">
                                                Boleto
                                            </label>
                                        </div>
                                        <div className="checkboxDivFormasPagamento">
                                            <Field
                                                as={Checkbox}
                                                name="pagamentoEscelsa"
                                                id="pagamentoEscelsa"
                                                color="primary"

                                            />
                                            <label className="p-checkbox-label">
                                                Escelsa
                                            </label>
                                        </div>
                                    </div>
                                    <ErrorMessage
                                        component="span"
                                        name="formasPagamento"
                                        style={{ color: 'red', fontSize: 12 }}
                                    />
                                </div>
                            </div>
                            <div className="div-input">
                                <Field
                                    name="dataAgendamento"
                                    render={({ field, form: { touched, errors } }) => (
                                        <>
                                            <Calendar
                                                locale={ptBR}
                                                {...field}
                                                placeholder="Data agendamento"
                                                style={{ width: '100%' }}
                                                minDate={amanha}
                                                dateFormat="dd/mm/yy"
                                                className={
                                                    !touched[field.name] ?
                                                        'input-empty' :
                                                        errors[field.name] ?
                                                            'input-wrong' :
                                                            'input-ok'
                                                }
                                            />
                                            {errors[field.name] &&
                                                touched[field.name] && (
                                                    <p>{errors[field.name]}</p>
                                                )}
                                        </>
                                    )}
                                />
                            </div>

                            <div className="actions-form">
                                <button
                                    type="submit"
                                    disabled={
                                        !isValid
                                    }

                                >
                                    <VscSave size={18} color="white" />
                                    <span>Salvar</span>
                                </button>
                                <button
                                    onClick={onAgendamento.bind(
                                        this,
                                        values,
                                        resetForm


                                    )}
                                    disabled={
                                        !isValid
                                    }
                                    type="button"
                                >
                                    <BiCalendarPlus size={22} color="white" />
                                    <span>Agendar</span>
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            )}
            {loadEnvioPlanos && <ProgressSpinner />}
            <DialogSuccessNoReload
                messageHeader="Planos cadastrados e editados com sucesso!"
                messageBody="Todas as alterações foram salvas!"
                openDialog={openDialogSuccess}
                setOpenDialog={setOpenDialogSuccess}
            />
            <DialogErrorNoReload
                messageHeader="Nenhuma alteração realizada!"
                messageBody={
                    dialogMessageErr ?
                        dialogMessageErr :
                        'Houve um problema ao salvar as alterações, tente novamente!'
                }
                openDialog={openDialogError}
                setOpenDialog={setOpenDialogError}
            />
        </div>
    );
}
